<template>
    <v-card elevation="0" class="pa-7">
        <v-card-text class="pa-1">
            <v-row no-gutters>
                <v-col>
                    <p class="title text--primary">
                        {{ this.planPackage.name }}
                    </p>
                </v-col>
                <v-col>
                    <div class="text-right subtitle-1">
                        <strong>
                            {{
                                $t(
                                    'resources.planPackage.form.labels.base-price',
                                )
                            }}:
                        </strong>

                        {{ this.planPackage.formattedPrice }}
                    </div>
                </v-col>
            </v-row>
        </v-card-text>

        <v-divider v-if="planProposal"></v-divider>

        <v-card-text v-if="planProposal">
            <p>
                <strong
                    >{{ $t('resources.planProposal.labels.loyalty') }}:</strong
                >
                {{
                    this.planProposal.proposal.loyalty
                        ? $t('dialogs-confirm.buttons.yes')
                        : $t('dialogs-confirm.buttons.no')
                }}
            </p>
            <p>
                <strong
                    >{{ $t('resources.planProposal.labels.new-plan') }}:</strong
                >
                {{
                    this.planProposal.proposal.new_plan
                        ? $t('dialogs-confirm.buttons.yes')
                        : $t('dialogs-confirm.buttons.no')
                }}
            </p>
            <p>
                <strong
                    >{{
                        $t(
                            'resources.planProposal.labels.setup-and-configuration',
                        )
                    }}:</strong
                >
                {{
                    this.planProposal.proposal.setup_and_configuration
                        ? $t('dialogs-confirm.buttons.yes')
                        : $t('dialogs-confirm.buttons.no')
                }}
            </p>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: {
        planPackage: {
            type: Object,
            required: true,
        },
        planProposal: {
            type: Object,
            required: false,
        },
    },
}
</script>

<style></style>
